import React from "react"
import PropTypes from "prop-types"
import { Field, reduxForm, Form } from "redux-form"
import { compose } from "recompose"
import { connect } from "react-redux"
import { Button, Icon } from "antd"
import { FormattedMessage } from "react-intl"
import Text from "../text"
import Box from "../../lib/ui/ui-box"
import Validators from "../../lib/validators"
import * as Normalizers from "../../lib/normalizers"
import { defaultValues } from "./options"
import renderTextfield from "../render-textfield"
import _provinces from "../../utils/provinces.data"
import * as Data from "../../utils/new-mortgage.data"
import { agesSelect } from "../../utils/ages.data"

const Provinces =
  localStorage.currentLocale === "fr-CA" ? _provinces.fr : _provinces.en

const _renderTowns = (props, province) => {
  if (province === "on") {
    return (
      <Field
        name="calculatorTown"
        id="calculatorTown"
        placeholder={props.i18n.messages["calculator.town.placeholder"]}
        validate={[Validators.isRequired]}
        component="select"
      >
        <option value="">Select</option>
        {Data.towns[province].map(town => (
          <option key={town} value={town}>
            {town}
          </option>
        ))}
      </Field>
    )
  } else if (province === "bc") {
    return (
      <Field
        name="calculatorTown"
        id="calculatorTown"
        placeholder={props.i18n.messages["calculator.town.placeholder"]}
        validate={[Validators.isRequired]}
        component="select"
      >
        <option value="">Select</option>
        {Data.towns[province].map(town => (
          <option key={town} value={town}>
            {town}
          </option>
        ))}
      </Field>
    )
  } else if (province === "ab") {
    return (
      <Field
        name="calculatorTown"
        id="calculatorTown"
        placeholder={props.i18n.messages["calculator.town.placeholder"]}
        validate={[Validators.isRequired]}
        component="select"
      >
        <option value="">Select</option>
        {Data.towns[province].map(town => (
          <option key={town} value={town}>
            {town}
          </option>
        ))}
      </Field>
    )
  } else {
    return (
      <Field
        name="calculatorTown"
        id="calculatorTown"
        placeholder={props.i18n.messages["calculator.town.placeholder"]}
        validate={[Validators.isRequired]}
        component="select"
      >
        <option value="">Select</option>
        {Data.towns["any"].map(town => (
          <option key={town} value={town}>
            {town}
          </option>
        ))}
      </Field>
    )
  }
}

const Step = props => {
  return (
    <Form onSubmit={props.handleSubmit}>
      <Box flexDirection="column" w={1} mx="auto" maxWidth={"400px"}>
        {/* Title */}
        <Text
          fontFamily="Libre Baskerville"
          fontSize={[3, 4]}
          lineHeight={[3, 4]}
          fontWeight="700"
          color="#2B3E51"
          mb={[2]}
        >
          <FormattedMessage id="calculator.title" />
        </Text>
        {/* Field Group */}
        <Box flexDirection="column" w={1}>
          {/* Field Title */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[0, 1]}
            lineHeight={[0, 3]}
            fontWeight="400"
            color="#2B3E51"
          >
            <FormattedMessage id="calculator.province.title" />
          </Text>
          {/* Province Field */}
          <Field
            name="calculatorProvince"
            id="calculatorProvince"
            placeholder={props.i18n.messages["calculator.province.placeholder"]}
            validate={[Validators.isRequired]}
            component="select"
          >
            {Provinces.map(province => (
              <option key={province.value} value={province.value}>
                {province.label}
              </option>
            ))}
          </Field>
        </Box>
        {/* Field Group */}
        <Box flexDirection="column" w={1} mt={[3]}>
          {/* Field Title */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[0, 1]}
            lineHeight={[0, 3]}
            fontWeight="400"
            color="#2B3E51"
          >
            <FormattedMessage id="calculator.town.title" />
          </Text>
          {/* Town Field */}
          {_renderTowns(props, props.calculatorProvince)}
        </Box>
        {/* Field Group */}
        <Box flexDirection="column" w={1} mt={[3]}>
          {/* Field Title */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[0, 1]}
            lineHeight={[0, 3]}
            fontWeight="400"
            color="#2B3E51"
          >
            <FormattedMessage id="calculator.ageOfYoungestHomeOwner.title" />
          </Text>
          {/* Age Of The Youngest Home Owner Field */}
          <Field
            name="calculatorAgeOfYoungestHomeOwner"
            id="calculatorAsgeOfYoungestHomeOwner"
            placeholder={
              props.i18n.messages[
                "calculator.ageOfYoungestHomeOwner.placeholder"
              ]
            }
            validate={[Validators.isRequired]}
            component="select"
          >
            <option value="">Select</option>
            {/* From 55 to 85 */}
            {agesSelect.map(age => (
              <option key={age} value={age}>
                {age}
              </option>
            ))}
          </Field>
        </Box>
        {/* Field Group */}
        <Box flexDirection="column">
          {/* Field Title */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[0, 1]}
            lineHeight={[0, 3]}
            fontWeight="400"
            color="#2B3E51"
            mt={[3]}
          >
            <FormattedMessage id="calculator.estimatedValueOfYourHome.title" />
          </Text>
          {/* Province Field */}
          <Field
            name="calculatorEstimatedHomeValue"
            id="calculatorEstimatedValueOfYourHome"
            placeholder={
              props.i18n.messages[
                "calculator.estimatedValueOfYourHome.placeholder"
              ]
            }
            format={Normalizers.chain([
              Normalizers.normalizeWithMax(9999999),
              Normalizers.normalizeMoney
            ])}
            normalize={Normalizers.normalizeToNumber}
            validate={[Validators.isRequired]}
            component={renderTextfield}
          />
        </Box>
      </Box>
      {/* Submit Button */}
      <Box mt={[3]}>
        <Button.Group size="large" onClick={props.handleSubmit}>
          <Button
            disabled={
              props.isCalculatorValid &&
              props.calculatorEstimatedHomeValue > 250000
                ? false
                : true
            }
            type="primary"
            htmlType="button"
          >
            <FormattedMessage id="newMortgage.calculator.cta" />
            <Icon type="right" />
          </Button>
        </Button.Group>
      </Box>
    </Form>
  )
}

Step.propTypes = {
  isFlowInvalid: PropTypes.bool.isRequired
}

export default compose(
  connect(state => ({
    initialValues: defaultValues
  })),
  reduxForm({
    form: "newMortgageWizard",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(Step)



// WEBPACK FOOTER //
// ./src/components/new-mortgage-wizard/step-calculator.component.js